import styled from 'styled-components';
import { colorTheme } from '@styles/muiTheme';

export const Wrapper = styled.div`
  color: ${colorTheme.palette.common.white};
  padding: 18px 20px;
  border-radius: 8px;
  background: ${colorTheme.palette.grey[500]};
`;

export const ControlsGroup = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 10px;
  align-items: center;
`;

export const LabelGroup = styled.div`
  color: ${colorTheme.palette.common.black};
  max-height: 40px;

  .MuiTypography-root {
    color: ${colorTheme.palette.common.black};
  }

  a {
    color: ${colorTheme.palette.primary.light};
    font-weight: 700;
  }
`;

export const Label = styled.div<{ margin?: string }>`
  line-height: 19px;
  margin: ${({ margin }) => margin || '-5px 0 -5px'};
  font-weight: 700;
`;
